export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetSkin(context) {
      context.commit("updateSkin", false)
    },
  },
  mutations: {
    updateSkin(state, data) {
      return state.data = data
    }
  }
}